<template>
  <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44
      C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22
      C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29
      C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22
      C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54
      C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94
      C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18
      C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71
      C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03
      C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93
      C8.24 10.01 8.25 10.08 8.27 10.16
      C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64
      C9.73 12.16 10.21 12.69 10.73 13.22
      C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61
      C13.66 15.63 13.72 15.66 13.79 15.69
      C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C
      15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C
      16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L
      21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
      :stroke="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    width: {
      type: String,
      default: '20',
    },
    height: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
    svgWidth() {
      return this.width;
    },
    svgHeight() {
      return this.height;
    },
  },
};
</script>
